import React, { useEffect, Fragment } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import ym from 'react-yandex-metrika';

import { socket } from '../api/config';

import {
  expertsActions,
  imageModalActions,
  messagesActions,
  metaActions,
  dialogsActions
} from '../store/actions';
import {
  getCurrentDialogId,
  getDialogsItems,
  getVisitorId,
  getIsTyping,
  getImagePreview,
  getMessagesItems,
} from '../store/selectors';
import { getCookie, setCookie } from '../utils';
import { initPosthog } from '../utils/posthog';

import ChatWindow from '../components/ChatWindow';
import MenuModal from '../components/MenuModal';

const {
  REACT_APP_POSTHOG_KEY: POSTHOG_KEY,
  REACT_APP_POSTHOG_HOST: POSTHOG_HOST
} = process.env;

const ChatWindowContainer = ({
  sendMessage,
  sendMessageWithFile,
  addBuyerChoice,
  setImages,
  uploadFile,
  resetImagePreview,
  typingChange,
  isWidgetPath,
  getCarBrands,
  getDialogs,
  setCurrentDialogId,
}) => {
  const dispatch = useDispatch();
  const currentDialogId = useSelector(getCurrentDialogId);
  const dialogs = useSelector(getDialogsItems);
  const visitorId = useSelector(getVisitorId);
  const isTyping = useSelector(getIsTyping);
  const imagePreview = useSelector(getImagePreview);
  const messages = useSelector(getMessagesItems);

  window.onbeforeunload = () => {
    if (isTyping) {
      socket.emit('typing', { isTyping: false });
    }
  };

  const handleType = (value) => {
    if (!isTyping && value) {
      typingChange(value);
    } else if (isTyping) {
      typingChange(value);
    }
  };

  const handleSendMessageWithFile = (caption, image) => {
    sendMessageWithFile(caption, image, currentDialogId);
  };

  useEffect(() => {
    const chatStartSentCookie = getCookie('chatStartSent');
    if (!chatStartSentCookie) {
      const today = new Date();
      const tomorrow = new Date();
      tomorrow.setDate(today.getDate() + 1);
      tomorrow.setHours(0, 0, 0);
      ym('reachGoal', 'CHAT_START');
      setCookie('chatStartSent', 'true', tomorrow);
    }
    initPosthog(POSTHOG_KEY, POSTHOG_HOST);
  }, []);

  useEffect(() => {
    if (messages) {
      return;
    }

    setImages(messages);
  }, [setImages, messages]);

  useEffect(() => {
    if (visitorId) {
      getCarBrands();
    }
  }, [getDialogs, getCarBrands, visitorId]);

  useEffect(() => {
    if (!currentDialogId && dialogs && dialogs.length > 0) {
      setCurrentDialogId(dialogs[0].dialog_id);
    }

    if (dialogs.length === 1 && dialogs[0].expert_id === null) {
      dispatch(expertsActions.setCallNewExpertButtonDisabled(true));
    }
  }, [dialogs]);


  return (
    <Fragment>
      <ChatWindow
        sendMessage={sendMessage}
        onPostFile={uploadFile}
        imagePreview={imagePreview}
        sendMessageWithFile={handleSendMessageWithFile}
        resetImagePreview={resetImagePreview}
        onType={handleType}
        addBuyerChoice={addBuyerChoice}
        isWidgetPath={isWidgetPath}
      />
      <MenuModal />
    </Fragment>
  );
};

export default connect(() => ({}), {
  ...imageModalActions,
  ...messagesActions,
  ...metaActions,
  ...expertsActions,
  ...dialogsActions,
})(ChatWindowContainer);
